export default {
  paramWind: 1,
  paramPressure: 4,
  paramTemp: 5,
  paramTide: 10,
  paramWaterLevel: 137,
  paramHumidity: 139
}